import { useQuery } from '@tanstack/react-query';
import { assetManagementWidgetsService } from '../services/asset-management-widgets-service';

// Asset Health Overview
export const useAssetHealthOverview = () => {
  return useQuery({
    queryKey: ['asset-management', 'health-overview'],
    queryFn: () => assetManagementWidgetsService.getAssetHealthOverview(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Maintenance & Insurance Due
export const useMaintenanceInsuranceDue = (limit: number = 10) => {
  return useQuery({
    queryKey: ['asset-management', 'maintenance-insurance-due', limit],
    queryFn: () => assetManagementWidgetsService.getMaintenanceInsuranceDue(limit),
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

// Audit Status
export const useAuditStatus = () => {
  return useQuery({
    queryKey: ['asset-management', 'audit-status'],
    queryFn: () => assetManagementWidgetsService.getAuditStatus(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Exception Alerts
export const useExceptionAlerts = (limit: number = 10) => {
  return useQuery({
    queryKey: ['asset-management', 'exception-alerts', limit],
    queryFn: () => assetManagementWidgetsService.getExceptionAlerts(limit),
    staleTime: 1 * 60 * 1000, // 1 minute
  });
};

// Lifecycle Stage
export const useLifecycleStage = () => {
  return useQuery({
    queryKey: ['asset-management', 'lifecycle-stage'],
    queryFn: () => assetManagementWidgetsService.getLifecycleStage(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Asset Age Analysis
export const useAssetAgeAnalysis = () => {
  return useQuery({
    queryKey: ['asset-management', 'age-analysis'],
    queryFn: () => assetManagementWidgetsService.getAssetAgeAnalysis(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Recent Asset Activity
export const useRecentAssetActivity = (limit: number = 20) => {
  return useQuery({
    queryKey: ['asset-management', 'recent-activity', limit],
    queryFn: () => assetManagementWidgetsService.getRecentAssetActivity(limit),
    staleTime: 1 * 60 * 1000, // 1 minute
  });
};
